//引入api接口
import { fun_PostAction, fun_GetKeys } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************项目信息***************************/
      tenderMakeId: null, // 标书文件制作表主键
      /*************************标段信息***************************/
      // 列表loading状态
      loading: false,
      form: {
        projectName: null,
        tenderName: null,
        tenderAgentOrgan: null,
        tenderMakeId: null,
        processState: null,
        decodeState: null,
        bidEndDate: null,
        reviewStartDate: null
      },
      // 表单配置
      formConfigList: [
        {
          label: "项目名称：",
          value: "projectName",
          type: "slot",
          slotName: "projectName"
        },
        {
          label: "招标人：",
          value: "tenderName",
          type: "slot",
          slotName: "tenderName"
        },
        {
          label: "招标代理：",
          value: "tenderAgentOrgan",
          type: "slot",
          slotName: "tenderAgentOrgan"
        },
        {
          label: "招标编号：",
          value: "tenderMakeId",
          type: "slot",
          slotName: "tenderMakeId"
        },
        {
          type: "select",
          label: "流程状态：",
          value: "processState",
          queryParams: {
            sqlId: "13f3e366-dbb0-4ea2-a6bf-6b84339ab42c",
            dictionaryId: "1547137980745449472"
          }
        },
        {
          type: "select",
          label: "解密状态：",
          value: "decodeState",
          queryParams: {
            sqlId: "13f3e366-dbb0-4ea2-a6bf-6b84339ab42c",
            dictionaryId: "1531963677833383940"
          }
        },
        {
          label: "开标时间：",
          value: "bidEndDate",
          type: "date",
          dateType: "datetime",
          required: true,
          disabled: false,
          rule: {
            required: true,
            message: "请输入标书下载截止时间",
            trigger: "blur"
          }
        },
        {
          label: "评标开始时间：",
          value: "reviewStartDate",
          type: "date",
          dateType: "datetime",
          required: true,
          disabled: false,
          rule: {
            required: true,
            message: "请输入评标开始时间",
            trigger: "blur"
          }
        }
      ],
      tableColumns: [
        {
          label: "专家姓名",
          prop: "expertName"
        },
        {
          label: "流程节点",
          prop: "nodeName"
        }
      ],
      tableData: [],
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      drawerStatus: false,
      // 表单配置
      formDetailConfigList: [
        {
          type: "slot",
          label: "专家：",
          slotName: "expert"
        },
        {
          type: "slot",
          label: "流程节点：",
          slotName: "processNode"
        }
      ],
      // 勾选的数据
      multipleSelection: [],
      // 专家编号
      expertId: null,
      // 流程节点编号
      processNodeId: null,
      // 任务编号
      taskId: null,
      // 专家下拉框的数据
      expert: [],
      // 流程节点下拉框的数据
      processNode: []
    };
  },

  mounted() {
    // 资格预审标志
    this.prequalificationType = this.$route.query.prequalificationType;
    // 标书文件制作表主键
    this.tenderMakeId = this.$route.query.tenderMakeId;
    // 获取项目信息
    this.fun_GetProjectInfo();
    // 获取任务信息
    this.fun_GetTaskList();
  },
  // 自定义事件
  methods: {
    /***********************************项目信息**************************************/
    /**
     * 获取项目信息
     */
    fun_GetProjectInfo() {
      // 请求
      fun_PostAction("/tenderSection/getProjectInfo", {
        tenderMakeId: this.tenderMakeId,
        prequalificationType: this.prequalificationType
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 项目名称
          this.form.projectName = data.projectName;
          // 招标人
          this.form.tenderName = data.tenderName;
          // 招标代理机构
          this.form.tenderAgentOrgan = data.tenderAgentOrgan;
          // 项目编号
          this.form.tenderMakeId = this.tenderMakeId;
          // 流程状态
          this.form.processState = data.processState;
          // 解密状态
          this.form.decodeState = data.decodeState;
          // 开标时间
          this.form.bidEndDate = data.bidEndDate;
          // 评标开始时间
          this.form.reviewStartDate = data.reviewStartDate;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },

    /***********************************标段信息**************************************/
    /**
     * 获取任务信息
     */
    fun_GetTaskList() {
      // 打开loading
      this.loading = true;
      // 执行获取列表接口
      fun_PostAction("projectManager/getTaskList", {
        recordNumber: this.tenderMakeId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.tableData = data;
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 打开抽屉
          this.drawerStatus = true;
          this.processNodeId = null;
          this.expertId = null;
          this.taskId = null;
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
      }
    },
    /**
     * 点击修改按钮
     * @author 滕威
     */
    fun_Edit() {
      console.log(this.multipleSelection);
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 打开抽屉
          this.drawerStatus = true;
          this.processNodeId = this.multipleSelection[0].processNodeId;
          this.expertId = this.multipleSelection[0].expertId;
          this.taskId = this.multipleSelection[0].id;
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 点击删除按钮
     * @author 滕威
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 弹出询问confirm
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 发起请求，获取结果集
          fun_PostAction("/projectManager/deleteTask", {
            json: JSON.stringify(this.multipleSelection)
          })
            .then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 请求一览查询接口
                this.fun_GetTaskList();
                // 保存成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
              // 取消确定按钮loading状态
              this.loading = false;
            })
            .catch(() => {
              // 取消确定按钮loading状态
              this.loading = false;
            });
        });
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     * @author 滕威
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    fun_GetSelectVal(e) {
      this.form.roleId = e;
    },
    fun_GetSelectVal1(e) {
      console.log(e);
    },
    /**
     * 打开抽屉
     */
    fun_DrawerOpen() {
      this.fun_GetExpert();
      this.fun_GetProcessNode();
    },
    /**
     * 关闭抽屉
     */
    fun_DrawerClose() {},
    /**
     * 获取专家下拉框的
     */
    fun_GetExpert() {
      // 请求，获取结果集
      fun_PostAction("/projectManager/getExpertList", {
        tenderMakeId: this.tenderMakeId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 评标办法下拉框
          this.expert = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    fun_GetProcessNode() {
      // 请求，获取结果集
      fun_PostAction("/projectManager/getProcessNode", {
        tenderMakeId: this.tenderMakeId,
        prequalificationType: this.prequalificationType
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 评标办法下拉框
          this.processNode = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 详情提交
     */
    fun_SubmitForm() {
      // 发起请求，获取结果集
      fun_PostAction("/projectManager/insertOrUpdateTask", {
        tenderMakeId: this.tenderMakeId,
        processNodeId: this.processNodeId,
        expertId: this.expertId,
        taskId: this.taskId
      })
        .then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 请求一览查询接口
            this.fun_GetTaskList();
            // 关闭弹窗
            this.drawerStatus = false;
            // 保存成功
            this.$message.success(msg);
          } else {
            // 请求失败，提示信息
            this.$message.error(msg);
          }
          // 取消确定按钮loading状态
          this.loading = false;
        })
        .catch(() => {
          // 取消确定按钮loading状态
          this.loading = false;
        });
    },
    /**
     * 提交
     * @author shuhua
     */
    fun_Submit() {
      // 执行获取列表接口
      fun_PostAction("projectManager/updateProjectInfo", {
        tenderMakeId: this.tenderMakeId,
        json: JSON.stringify(this.form)
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          this.fun_GetProjectInfo();
          // 提示信息
          this.$message.success(msg);
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 返回
     * @author 滕威
     */
    fun_Back() {
      this.$router.back();
    }
  }
};
